export function linkToAccountPage() {
  return "/account";
}
